import { render, staticRenderFns } from "./AvailabilityForm.vue?vue&type=template&id=552e56dc&scoped=true"
import script from "./AvailabilityForm.vue?vue&type=script&lang=js"
export * from "./AvailabilityForm.vue?vue&type=script&lang=js"
import style0 from "./AvailabilityForm.vue?vue&type=style&index=0&id=552e56dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552e56dc",
  null
  
)

export default component.exports